<template>
    <Modal
        :title="$t('popup.leave.title')"
        :submit-text="$t('popup.leave.submitText')"
        @cancel="close"
        @submit="onSubmit"
    >
        <InputCheckbox v-model="keepFollowedDocuments">
            {{ $t('popup.leave.label_follow_documents') }}
        </InputCheckbox>
    </Modal>
</template>

<script>
import Modal from '@components/Modal';
import ModalMixin from '@mixins/modalMixin';

export default {
    name: 'ModalConfirmCourseLeave',
    components: {
        Modal,
    },
    extends: ModalMixin,
    i18nOptions: {
        namespaces: ['course'],
    },
    data: () => ({
        keepFollowedDocuments: true,
    }),
    methods: {
        onSubmit() {
            this.close({
                keepDocuments: this.keepFollowedDocuments,
            });
        },
    },
};
</script>
